import { render } from "./registration.vue?vue&type=template&id=c462f6dc&scoped=true"
import script from "./registration.vue?vue&type=script&lang=js"
export * from "./registration.vue?vue&type=script&lang=js"

import "./registration.vue?vue&type=style&index=0&id=c462f6dc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c462f6dc"]])

export default __exports__